import Link from 'next/link'
import Head from 'next/head'
import Layout from '../../components/layout'

export default function Service() {
    return (
        <Layout>
            <Head>
                <title>Услуги фото- и видеосъемки, создание виртуального тура в360.рф</title>
                <meta name="description" content="Заказ виртуального тура в Томске и области. Размещение виртуального тура на сайте." />
                <meta name="keywords" content="разместить виртуальный тур на сайт, сделать 3д тур в томске, сделать панораму, сделать панорамное фото, заказать съемку vr тура" />
            </Head>
            <h1>Заказать съемку 360</h1>
            <h2>
                <Link href="/">
                    <a>На главную</a>
                </Link>
            </h2>
            <p>
                По вопросам съемки и сотрудничества обращайтесь по телефону
                {' '}<a href="tel:+79959650505">+7 995 965 0505</a> или пишите в
                {' '}<Link a href="/posts/social">социальных сетях</Link>.
            </p>

            <p>
                Виртуальный тур позволяет сделать презентацию с эффектом полного погружения, такие фото и видео гораздо интереснее обычных и привлекают больше внимания.
                Стоимость виртуального тура обсуждается индивидуально и зависит от сервиса для размещения тура, количества точек для съемки и расположения Вашего объекта.
                Мы делаем инновации доступными для всех, используем современное оборудование и новейшие технологии. Это позволяет нам проводить съемку в сжатые сроки и оперативно предоставлять ссылку на готовый виртуальный тур.
            </p>
            <p>
                Пример виртуального тура:
            </p>
                <iframe src="https://в360.рф/tour/01d85pp1982gf6ktvfhq7w78fb/" frameBorder="0" loading="lazy" width="100%"
                    height="600"></iframe>

            <p>3D тур по студии красоты и квартире с размещением на сервисе Matterport:</p>
                <iframe width='100%' height='480' src='https://my.matterport.com/show/?m=NZq6AR2EcHt' loading="lazy" frameBorder='0'
                        allowFullScreen allow='xr-spatial-tracking'></iframe>

                <iframe width='100%' height='480' src='https://my.matterport.com/show/?m=4QYRRsesR3p' loading="lazy" frameBorder='0'
                        allowFullScreen allow='xr-spatial-tracking'></iframe>

            <p>Также у нас есть услуга по размещению панорам в Google Street View(Просмотр улиц) и Яндекс.Панорамы.</p>
            <br />
            Ближайшие регионы для съемки: Томская область, Новосибирская область, Кемеровская область, Красноярский край. Готовы снимать по всей России по договоренности.
            <br />
            <p>VR, виртуальный тур по квартире в Томске, 3D тур в Томске </p>

        </Layout>
    )
}